import React, { useCallback } from 'react';
import { IMaskInput } from 'react-imask';

interface TextInputProps {
  name: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  placeholder?: string;
  mask?: string;
  definitions?: { [key: string]: RegExp };
  overwrite?: boolean;
}

const CustomMaskFormat = React.forwardRef<HTMLElement, TextInputProps>(
  function TextInput(props, ref) {
    const {
      onChange,
      mask = '00-0000000',
      placeholder = 'XX-XXXXXXX',
      definitions = { '#': /[1-9]/ },
      overwrite = true,
      ...other
    } = props;

    return (
      <IMaskInput
        {...other}
        mask={mask}
        definitions={definitions}
        placeholder={placeholder}
        ref={ref}
        onAccept={useCallback(
          (value: string) =>
            onChange({ target: { name: props.name, value: value as string } }),
          [onChange, props.name],
        )}
        overwrite={overwrite}
      />
    );
  },
);

export { CustomMaskFormat };
